export default __webpack_public_path__ + "static/media/ic-operation.51d6e6b5.svg";